// 支付类型
export enum STATUS {
  IS_A_BILL = 'IS_A_BILL',
  HAD_CHECK_OUT = 'HAD_CHECK_OUT',
}
// 支付状态多语言
export const STATUS_MAP = {
  [STATUS.IS_A_BILL]: 'subscribe.bills.payStatus.unpaid', // 未支付
  [STATUS.HAD_CHECK_OUT]: 'subscribe.bills.payStatus.paid', // 已支付
}

// 账单详情分页默认配置
export const CodBillDetailPageConfig = {
  pageSize: 2000,
  pageNum: 1,
}

// 支付类型选项
export const STATUS_OPTIONS = [
  { label: STATUS_MAP.IS_A_BILL, key: STATUS.IS_A_BILL },
  { label: STATUS_MAP.HAD_CHECK_OUT, key: STATUS.HAD_CHECK_OUT },
]

// 筛选条件-时间类型
export const TIME_TYPE = [
  { label: 'codBill.billRange', value: 1 }, // 账单周期
  { label: 'codBill.creatTime', value: 2 }, // 生成时间
]
